import { from, concatMap, filter, tap } from 'rxjs'
import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { handleMessages, refreshToken } from '../../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    inboxMessages: [],
    selectedInboxMessage: null,
    selectedInboxMessages: []
  }),
  actions: {
    getInboxMessages(
      context,
      { token, config = {} } = { token: null, config: {} }
    ) {
      const { rootState, commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/message/v2/getMessageByUser`,
                {},
                getAxiosConfig(context, {
                  ...config,
                  headers: {
                    ...config.headers,
                    Authorization:
                      'Bearer ' + (token || rootState.authModule.token)
                  }
                })
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('INBOX_MESSAGES', data)
          })
        )
        .toPromise()
    },
    read(context) {
      const { state, commit, rootState } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/message/readEmail`,
                {
                  msgId: state.selectedInboxMessage.id
                },
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit(
              'authModule/USER',
              {
                ...rootState.authModule.user,
                unReadMsgCount: data.unreadCount
              },
              { root: true }
            )
            commit('SELECTED_INBOX_MESSAGE', {
              ...state.selectedInboxMessage,
              isRead: true
            })
            commit(
              'INBOX_MESSAGES',
              state.inboxMessages.map(inboxMessage => {
                if (state.selectedInboxMessage.id === inboxMessage.id) {
                  return {
                    ...inboxMessage,
                    isRead: true
                  }
                }
                return inboxMessage
              })
            )
          })
        )
        .toPromise()
    },
    delete(context) {
      const { state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/message/changeMessageStatusByUser/DELETE`,
                {
                  msgIds: state.selectedInboxMessages.map(
                    selectedInboxMessage => selectedInboxMessage.id
                  )
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    readAll(context) {
      const { state } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/message/changeMessageStatusByUser/READ`,
                {
                  msgIds: state.selectedInboxMessages.map(
                    selectedInboxMessage => selectedInboxMessage.id
                  )
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    }
  },
  mutations: {
    INBOX_MESSAGES(state, payload) {
      state.inboxMessages = payload
    },
    SELECTED_INBOX_MESSAGE(state, payload) {
      state.selectedInboxMessage = payload
    },
    SELECTED_INBOX_MESSAGES(state, payload) {
      state.selectedInboxMessages = payload
    }
  },
  getters: {
    inboxMessages: state => state.inboxMessages,
    selectedInboxMessage: state => state.selectedInboxMessage,
    selectedInboxMessages: state => state.selectedInboxMessages
  }
}
